import { FEDOPS_OVERRIDES_COOKIE } from '@wix/fedops-overrides';
import { env } from './env';
export var CookieOverrides = /*#__PURE__*/function () {
  /**
   * @param {import('@wix/fedops-overrides').FedopsOverrideCookie} overridesCookie
   */
  function CookieOverrides() {
    this._overridesCookie = this._getOverridesFromDocumentCookieIfExists();
  }

  var _proto = CookieOverrides.prototype;

  _proto.getCookieOverridesForApp = function getCookieOverridesForApp(appName) {
    return Object.assign({}, this._overridesCookie.paramsOverrides, this._overridesCookie.paramsOverridesForApp && this._overridesCookie.paramsOverridesForApp[appName]);
  };

  _proto._getOverridesFromDocumentCookieIfExists = function _getOverridesFromDocumentCookieIfExists() {
    try {
      var overridesCookieContent = getCookie(FEDOPS_OVERRIDES_COOKIE);
      var overridesObject = parseJsonFromNodeOrScalaServers(overridesCookieContent);

      if (overridesObject && typeof overridesObject === 'object') {
        return overridesObject;
      } else {
        return {};
      }
    } catch (err) {
      return {};
    }
  };

  return CookieOverrides;
}();

function getCookie(cookieName) {
  if (!env().document || !env().document.cookie) {
    return '';
  }

  var cookieKeyValuePairs = env().document.cookie.split(';').map(function (c) {
    return c.trim().split('=');
  });

  var _cookieKeyValuePairs$ = cookieKeyValuePairs.filter(function (_ref) {
    var key = _ref[0];
    return key === cookieName;
  }),
      relevantCookie = _cookieKeyValuePairs$[0];

  if (relevantCookie) {
    var value = relevantCookie[1];
    return value;
  } else {
    return '';
  }
}

function parseJsonFromNodeOrScalaServers(rawPayload) {
  function attemptToParseJsonRecursivelySinceScalaServersSerializeItTwice() {
    try {
      return JSON.parse(JSON.parse(rawPayload));
    } catch (err) {
      return null;
    }
  }

  function attemptURIDecodeAndParseJsonSinceNodeServersUseWithURIEncoding() {
    try {
      return JSON.parse(decodeURIComponent(rawPayload));
    } catch (err) {
      return null;
    }
  }

  return attemptToParseJsonRecursivelySinceScalaServersSerializeItTwice() || attemptURIDecodeAndParseJsonSinceNodeServersUseWithURIEncoding();
}